import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useCsCfgObject } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
import { useConfigurationTypeCodeElement } from "./useConfigurationTypeCodeElement";
export function ConfigurationTypeCodeLink() {
    const cfgObject = useCsCfgObject();
    const t = useUiTranslator();
    const labelText = t("ConfigurationRenderer:ConfigurationTypeCode.label", "Type code");
    const { typeCodeElements = [] } = cfgObject;
    return (_jsxs(Box, { sx: { my: 2 }, children: [_jsx(Typography, { variant: "h6", color: "primary", children: labelText }), _jsx(Grid, { container: true, sx: { alignItems: "flex-end" }, children: typeCodeElements === null || typeCodeElements === void 0 ? void 0 : typeCodeElements.map((element, elementIndex) => (_jsx(Grid, { children: _jsx(ConfigurationTypeCodeLinkItem, { element: element }) }, elementIndex))) })] }));
}
function ConfigurationTypeCodeLinkItem(props) {
    const { element } = props;
    if (element.valueType != "Value") {
        return _jsx(NonClickableTypecodeElement, { element: element });
    }
    return (_jsx(TypeCodeValueElementNavigationStateLink, { element: element }));
}
function NonClickableTypecodeElement(props) {
    const { element } = props;
    // render not clickable link
    return _jsx(Typography, { color: "primary", children: element.value });
}
function TypeCodeValueElementNavigationStateLink(props) {
    return (_jsx(Suspense, { fallback: _jsx(NonClickableTypecodeElement, { element: props.element }), children: _jsx(TypeCodeValueElementNavigationStateLinkInner, Object.assign({}, props)) }));
}
function TypeCodeValueElementNavigationStateLinkInner(props) {
    const { element } = props;
    const { elementExists, handleElementClick } = useConfigurationTypeCodeElement(element);
    if (!elementExists) {
        return _jsx(NonClickableTypecodeElement, { element: element });
    }
    return (_jsx(Link, { color: "primary", component: "button", onClick: handleElementClick, children: element.value }));
}
//# sourceMappingURL=ConfigurationTypeCodeLink.js.map